import React, { useState, useEffect } from "react";
import { Button, Card, Form } from "antd";
import HeaderComponent from "components/card/HeaderComponent";
import HeaderModal from "components/modal/HeaderModal";
import { Send, CircleCheck } from "lucide-react";
import EmployeeSelector from "./EmployeeSelector";
import { USABLE_ICONS } from "variables/constants";
import {
  getAwardList,
} from "../../../../../redux/award/awardState";
import {
  doEmployeeAwardCreate,
  doEmployeeAwardReset,
} from "../../../../../redux/employeeaward/employeeAwardState";
import { connect } from "react-redux";

const AwardCategoryCard = ({
  recordList,
  pagination,
  nominationSuccess,
  getList,
  doCreate,
  doReset,
}) => {
  const [form] = Form.useForm();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedCategory(null);
    form.resetFields();
  };

  useEffect(() => {
    getList({ paginate: pagination?.per_page || 10 });
  }, [getList, pagination?.per_page]);

  useEffect(() => {
    if (nominationSuccess && isModalOpen) {
      closeModal();
      doReset();
    }
  }, [nominationSuccess, isModalOpen, doReset]);

  const handleSubmit = (values) => {
    doCreate(values);
  };

  return (
    <HeaderComponent
      title="Award Categories"
      titleClass="text-[16px] font-medium"
      description="Select an award category to nominate a team member"
      descriptionClass="text-sm"
    >
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {recordList?.map((category) => (
          <Card
            key={category.awd_id}
            onClick={() => {
              setSelectedCategory(category);
              setIsModalOpen(true);

              form.resetFields();
              form.setFieldsValue({
                ema_award_id: category.awd_id,
              });
            }}
            className={`card-theme ${category.awd_color_class.toLowerCase()} rounded-xl cursor-pointer hover:shadow-lg transition-all`}
          >
            <div className="space-y-4">
              <div className="flex flex-col items-start gap-3">
                <div className="icon-style p-3 text-white">
                  {category.awd_icon &&
                    USABLE_ICONS[category.awd_icon] &&
                    React.createElement(
                      USABLE_ICONS[category.awd_icon],
                      { className: "h-6 w-6" }
                    )}
                </div>

                <h4 className="card-text text-base">
                  {category.awd_title}
                </h4>

                <p className="text-[13px] text-muted-foreground">
                  {category.awd_description}
                </p>
              </div>

              <button
                className="h-8 rounded-2xl w-full icon-style !bg-gradient-to-r text-white inline-flex items-center justify-center font-semibold gap-3"
                onClick={() => {
                  setSelectedCategory(category);
                  setIsModalOpen(true);

                  form.resetFields();
                  form.setFieldsValue({
                    ema_award_id: category.awd_id,
                  });
                }}
              >
                <Send className="h-4 w-4" /> Nominate
              </button>
            </div>
          </Card>
        ))}
      </div>

      {isModalOpen && selectedCategory && (
        <HeaderModal
            open={isModalOpen}
            onClose={closeModal}
            title={`Nominate for ${selectedCategory.awd_title}`}
            titleClass="text-lg font-semibold pt-1 pb-4 flex"
            labelIcon={
              <div className={`card-theme ${selectedCategory.awd_color_class?.toLowerCase()} invisible`}>
                <div className="icon-style p-2 text-white visible">
                  {selectedCategory.awd_icon &&
                    USABLE_ICONS[selectedCategory.awd_icon] &&
                    React.createElement(USABLE_ICONS[selectedCategory.awd_icon], {
                      className: "h-5 w-5"
                    })}
                </div>
              </div>
            }
            description={selectedCategory.awd_description}
            descriptionClass="text-sm text-gray-700"
            bgcolor={selectedCategory.awd_color_class?.toLowerCase() || "white"}
            cardBorder={`border-${selectedCategory.awd_color_class?.toLowerCase() || "gray-200"}`}
            width={550}
            footer={
              <div className="p-4 flex justify-end gap-2">
                <Button
                  className="inline-flex items-center justify-center gap-2 rounded-xl text-sm text-gray-800 h-9 px-4"
                  onClick={closeModal}
                >
                  Cancel
                </Button>

                <div className={`card-theme ${selectedCategory.awd_color_class?.toLowerCase()} invisible`}>
                  <Button
                    icon={<CircleCheck size={16} />}
                    className="!bg-gradient-to-r icon-style inline-flex items-center justify-center visible text-white p-4 h-9 font-medium"
                    loading={submitting}
                    onClick={() => form.submit()}
                  >
                    Submit Nomination
                  </Button>
                </div>
              </div>
            }
        >
          <Form 
            form={form} 
            layout="vertical" 
            onFinish={handleSubmit}
          >
            <Form.Item name="ema_award_id" hidden>
              <input type="hidden" />
            </Form.Item>

            <EmployeeSelector />
          </Form>
        </HeaderModal>
      )}
    </HeaderComponent>
  );
};

const mapStateToProps = (state) => ({
  recordList: state.award.awardList?.items,
  pagination: state.award.awardList?.pagination,
  nominationSuccess: state.employeeAward.employeeAwardDetails?.success,
  loading:  state.employeeAward.employeeAwardDetails?.requesting,
});

const mapDispatchToProps = (dispatch) => ({
  getList: (params) => dispatch(getAwardList(params)),
  doCreate: (data) => dispatch(doEmployeeAwardCreate(data)),
  doReset: () => dispatch(doEmployeeAwardReset()),
});

export default connect(mapStateToProps, mapDispatchToProps)(AwardCategoryCard);